import $ from 'jquery'
import {orgText} from '../cads/cache/get'

const qbApiOrgIds = [5,7]

let estimatesData, purchaseOrderData, invoicesData

const getEstimatesCache = (orgId, callbackFunc) => {
  if (!qbApiOrgIds.includes(orgId)) return

  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/qb_api_cache/estimates' + orgText(orgId) + '.json?t=' + randomNum
  let url2 = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/qb_api_cache/vendor_orders' + orgText(orgId) + '.json?t=' + randomNum
  let url3 = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/qb_api_cache/invoices' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function(res) {
    estimatesData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })

  $.get(url2, function(res) {
    purchaseOrderData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })

  $.get(url3, function(res) {
    invoicesData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })
}

const callbackFuncLocal = (callbackFunc) => {
  if (estimatesData != null && purchaseOrderData != null && invoicesData != null) {
    callbackFunc(estimatesData, purchaseOrderData, invoicesData)
  }
}

export {getEstimatesCache, qbApiOrgIds}
